import React, { useState } from "react";

import { Grid, Box, Modal } from "@mui/material";
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { makeStyles } from '@material-ui/core/styles';
import TrainerDetailTable from "./TrainerDetailTable";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-60%, -60%)',
    width: 870,
    bgcolor: '#F5F7FF',
    boxShadow: 24,
    p: 2,
    borderTopRightRadius: 10,
    borderTopLeftRadius: 10,
    '@media (min-width: 1636px)':{
        width: 1010,
    }
  };
const TrainerDetailViewModal = (props) => {
    // Hooks
    const styles = useStyles();
    //const dispatch = useDispatch();

    //State
    const [tabValue, setTabValue] = useState('presentation');

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <Modal
            open={props.show}
            onClose={() => {
                if (!props.persistent) {
                    props.toggleModal(false);
                }
            }}
            sx={{position: 'absolute',
            top: '18%',
            left: '18%',
            p: 4,}}
        >
            <Grid 
                container
                sx={style}
            >
                <Grid item>
                    <Box                        
                       sx={{ mb: 1 }}
                    >
                        <TabContext value={tabValue}>
                            <Box sx={{ display: 'inline-flex', borderBottom: 1, borderBlockColor: '#EFEFEF', justifyContent: 'center',borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>
                                <TabList
                                    onChange={handleChange}
                                    aria-label="API tabs"
                                >
                                    <Tab label="Presentation"
                                        value="presentation"
                                        sx={{ textTransform: 'inherit', fontWeight: '600', color: '#7f97d8', fontSize: '1rem', '@media (min-width: 1636px)': { fontSize: '1.4rem' } }} to
                                    />
                                    <Tab label="Task"
                                        value="task"
                                        sx={{ textTransform: 'inherit', ml: 15, fontWeight: '600', color: '#7f97d8', fontSize: '1rem', '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}
                                    />
                                    <Tab label="Assignment"
                                        value="assignment"
                                        sx={{ textTransform: 'inherit', ml: 15, fontWeight: '600', color: '#7f97d8', fontSize: '1rem', '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}
                                    />
                                    <Tab label="Evaluation"
                                        value="evaluation"
                                        sx={{ textTransform: 'inherit', ml: 15, fontWeight: '600', color: '#7f97d8', fontSize: '1rem', '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}
                                    />
                                </TabList>
                            </Box>
                            <TabPanel value="presentation">
                                <TrainerDetailTable
                                    tableDetailData={props.courseDetailData}
                                />
                            </TabPanel>
                            <TabPanel value="task">
                                <TrainerDetailTable
                                    tableDetailData={props.taskDetailData}
                                />
                            </TabPanel>
                            <TabPanel value="assignment">
                                <TrainerDetailTable
                                    tableDetailData={props.assiDetailData}
                                />
                            </TabPanel>
                            <TabPanel value="evaluation">
                                <TrainerDetailTable
                                    tableDetailData={props.evalDetailData}
                                />
                            </TabPanel>
                        </TabContext>
                    </Box>
                </Grid>
            </Grid>
        </Modal>
    );
};
const useStyles = makeStyles({   
    scrollBar: {
        "&::-webkit-scrollbar": {
            width: "0.5em",
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "#ffe600ff",
            "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
            borderRadius: 5,
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#5f5600ff",
            borderRadius: 5,
        },
    }
});
export default TrainerDetailViewModal;